module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_gamepub_m2.81e0cbf7387d492565b2335d4c97d4df.png";